import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { PrazoPagamentoCliente } from '../../models/prazos-pagamento/prazo-pagamento-cliente';

@Injectable({
  providedIn: 'root'
})

export class PrazoPagamentoClienteService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getByClientIdApp(client_id_app: number): Observable<PrazoPagamentoCliente[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app
    };

    return this.http.post<PrazoPagamentoCliente[]>(this.baseUrl + "api/PrazoPagamentoCliente/GetByClientIdApp", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }
}
